import React from "react";

function YellowUser() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="18" cy="18" r="18" fill="#EFC72D" />
      <path
        d="M18 18C16.5625 18 15.25 17.25 14.5312 16C13.8125 14.7812 13.8125 13.25 14.5312 12C15.25 10.7812 16.5625 10 18 10C19.4062 10 20.7188 10.7812 21.4375 12C22.1562 13.25 22.1562 14.7812 21.4375 16C20.7188 17.25 19.4062 18 18 18ZM16.5625 19.5H19.4062C22.5 19.5 25 22 25 25.0938C25 25.5938 24.5625 26 24.0625 26H11.9062C11.4062 26 11 25.5938 11 25.0938C11 22 13.4688 19.5 16.5625 19.5Z"
        fill="#282A36"
      />
    </svg>
  );
}

export default YellowUser;
